import React, { useEffect, useState } from "react"
import { useOutletContext } from "react-router-dom"
import axios from "axios"
import { 
  FaUsers, FaCalendarAlt, FaNewspaper, FaTrophy, 
  FaChartLine, FaMoneyBillWave, FaCheckCircle, FaClock, FaChessKnight, FaFilter, FaFilePdf, FaHandHoldingUsd
} from "react-icons/fa"

export default function DashboardCircuito() {
  const { circuito } = useOutletContext()
  const [statsData, setStatsData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [loadingPdf, setLoadingPdf] = useState(false)

  useEffect(() => {
    if (circuito?._id) {
      axios.get(`https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/dashboard-stats`)
        .then(res => setStatsData(res.data))
        .catch(err => console.error("Erro ao buscar dashboard:", err))
        .finally(() => setLoading(false))
    }
  }, [circuito])

  // --- Função Mágica para baixar o PDF Financeiro ---
  const handleDownloadRelatorioFinanceiro = async () => {
    if (!circuito?._id) return;
    setLoadingPdf(true);
    
    try {
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/circuitos/${circuito._id}/relatorio-financeiro`,
        { responseType: 'blob' } // Diz ao axios que é um arquivo PDF
      );
      
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Financeiro-${circuito.nome}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar PDF Financeiro", error);
      alert("Erro ao gerar o relatório financeiro. Tente novamente.");
    } finally {
      setLoadingPdf(false);
    }
  };

  const receitaAprovada = statsData?.receita?.aprovada || 0;
  const receitaVendas = statsData?.receita?.vendas || 0;
  const entradasManuais = statsData?.receita?.entradas || 0;
  const receitaPendente = statsData?.receita?.pendente || 0;
  const qtdPagos = statsData?.associados?.pagos || 0;
  const qtdPendentes = statsData?.associados?.pendentes || 0;
  const cavalosVinculadosPagos = statsData?.associados?.cavalosVinculados || 0;
  const cavalosAvulsosPagos = statsData?.associados?.cavalosAvulsos || 0;

  const statsCards = [
    { icon: <FaUsers />, label: "Total de Associações", value: statsData?.associados?.total || "0", color: "#3b82f6" },
    { icon: <FaCheckCircle />, label: "Associações Pagas", value: qtdPagos, color: "#10b981" },
    { icon: <FaClock />, label: "Associações Pendentes", value: qtdPendentes, color: "#f59e0b" },
    { 
      icon: <FaMoneyBillWave />, 
      label: "Arrecadação Total", 
      value: `R$ ${receitaAprovada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`, 
      color: "#2ecc71" 
    },
    {
      icon: <FaMoneyBillWave />,
      label: "Receita de Vendas",
      value: `R$ ${receitaVendas.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
      color: "#38bdf8"
    },
    {
      icon: <FaHandHoldingUsd />,
      label: "Entradas Manuais",
      value: `R$ ${entradasManuais.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
      color: "#10b981"
    },
    { icon: <FaChessKnight />, label: "Cavalos c/ Vaqueiro", value: cavalosVinculadosPagos, color: "#a855f7" },
    { icon: <FaChessKnight />, label: "Cavalos Avulsos", value: cavalosAvulsosPagos, color: "#f59e0b" },
    { icon: <FaCalendarAlt />, label: "Etapas", value: statsData?.etapas || "0", color: "#8b5cf6" },
    { icon: <FaNewspaper />, label: "Notícias", value: statsData?.noticias || "0", color: "#6366f1" },
    { icon: <FaTrophy />, label: "Campeões", value: statsData?.campeoes || "0", color: "#ec4899" },
  ]

  if (loading) {
    return <div style={{ padding: "40px", textAlign: "center", color: "#fff" }}>Carregando dados do dashboard...</div>
  }

  return (
    <div>
      <div className="pc-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "16px" }}>
        <div>
          <h1 className="pc-page-header__title">Dashboard Financeiro</h1>
          <p className="pc-page-header__subtitle">
            Visão geral e arrecadação real do circuito {circuito?.nome}
          </p>
        </div>
        
        {/* BOTÃO DO PDF FINANCEIRO */}
        <button 
          onClick={handleDownloadRelatorioFinanceiro} 
          disabled={loadingPdf}
          style={{
            display: "flex", alignItems: "center", gap: "8px", background: "#10b981", color: "#fff", 
            padding: "12px 24px", borderRadius: "12px", border: "none", fontWeight: "bold", 
            fontSize: "1rem", cursor: "pointer", transition: "all 0.2s ease",
            boxShadow: "0 4px 14px rgba(16, 185, 129, 0.3)"
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
          onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
        >
          <FaFilePdf size={18} />
          {loadingPdf ? "Gerando Relatório..." : "Baixar Relatório Financeiro (PDF)"}
        </button>
      </div>

      <div className="pc-stats-grid" style={{ 
        display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", 
        gap: "16px", marginBottom: "24px" 
      }}>
        {statsCards.map((stat, idx) => (
          <div key={idx} className="pc-stat-card" style={{
            background: "var(--pc-bg-card)", padding: "20px", borderRadius: "16px",
            border: "1px solid var(--pc-border)", display: "flex", alignItems: "center", gap: "16px"
          }}>
            <div
              className="pc-stat-card__icon"
              style={{ 
                background: `${stat.color}20`, color: stat.color, width: "48px", height: "48px",
                borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px",
                flexShrink: 0
              }}
            >
              {stat.icon}
            </div>
            <div className="pc-stat-card__content" style={{ minWidth: 0 }}>
              <p className="pc-stat-card__value" style={{ fontSize: "20px", fontWeight: "bold", margin: 0, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {stat.value}
              </p>
              <span className="pc-stat-card__label" style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap", display: "block", overflow: "hidden", textOverflow: "ellipsis" }}>
                {stat.label}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
        
        {/* RELATÓRIO COMPLETO DE CATEGORIAS E LOTES */}
        <div className="pc-card">
          <div className="pc-card__header" style={{ marginBottom: "20px" }}>
            <h3 className="pc-card__title" style={{ fontSize: "18px" }}>
              <FaFilter style={{ marginRight: 10, color: "#3b82f6" }} />
              Relatório de Vendas por Categoria e Lote
            </h3>
            <p style={{ fontSize: "13px", color: "rgba(255,255,255,0.5)", marginTop: "4px", lineHeight: "1.5" }}>
              Valores separados por origem: associação, cavalo vinculado ao vaqueiro e cavalo avulso.
            </p>
          </div>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {statsData?.vendasPorCategoria?.map((cat, idx) => (
              <div key={idx} style={{ 
                background: "rgba(255,255,255,0.02)", borderRadius: "12px", 
                border: "1px solid rgba(255,255,255,0.06)", padding: "20px"
              }}>
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "16px", borderBottom: "1px dashed rgba(255,255,255,0.1)", paddingBottom: "16px" }}>
                  <strong style={{ fontSize: "18px", color: "#fff", textTransform: "uppercase" }}>
                    {cat.nome}
                  </strong>
                  <div style={{ textAlign: "right" }}>
                    <span style={{ color: "#2ecc71", fontWeight: "800", display: "block", fontSize: "16px" }}>
                      PAGO: R$ {cat.pagoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} <span style={{fontSize: "12px", fontWeight: "normal"}}>({cat.pagoQtd} pagamentos)</span>
                    </span>
                    <span style={{ color: "#f39c12", fontSize: "13px", display: "block", marginTop: "4px" }}>
                      PENDENTE: R$ {cat.pendenteTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} ({cat.pendenteQtd} un)
                    </span>
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "16px" }}>
                  
                  <div style={{ background: "rgba(56, 189, 248, 0.08)", padding: "16px", borderRadius: "10px", border: "1px solid rgba(56, 189, 248, 0.2)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed rgba(56, 189, 248, 0.3)", paddingBottom: "8px", marginBottom: "12px" }}>
                      <span style={{ fontSize: "12px", color: "#38bdf8", textTransform: "uppercase", fontWeight: "800", letterSpacing: "0.5px" }}>
                        1º Lote
                      </span>
                      <strong style={{ color: "#fff", fontSize: "16px" }}>
                        R$ {cat.lotes["1º Lote"].total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </strong>
                    </div>
                    
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "13px", color: "rgba(255,255,255,0.8)" }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>🤠 {cat.lotes["1º Lote"].qtdVaqueiros} Vaqueiros</span>
                        <span style={{ color: "#7dd3fc", fontWeight: "600" }}>R$ {cat.lotes["1º Lote"].valorVaqueiros.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>🐴 {cat.lotes["1º Lote"].qtdCavalosVinculados} Cavalos c/ vaqueiro</span>
                        <span style={{ color: "#7dd3fc", fontWeight: "600" }}>R$ {cat.lotes["1º Lote"].valorCavalosVinculados.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  </div>

                  <div style={{ background: "rgba(168, 85, 247, 0.08)", padding: "16px", borderRadius: "10px", border: "1px solid rgba(168, 85, 247, 0.2)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed rgba(168, 85, 247, 0.3)", paddingBottom: "8px", marginBottom: "12px" }}>
                      <span style={{ fontSize: "12px", color: "#a855f7", textTransform: "uppercase", fontWeight: "800", letterSpacing: "0.5px" }}>
                        2º Lote
                      </span>
                      <strong style={{ color: "#fff", fontSize: "16px" }}>
                        R$ {cat.lotes["2º Lote"].total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </strong>
                    </div>
                    
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "13px", color: "rgba(255,255,255,0.8)" }}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>🤠 {cat.lotes["2º Lote"].qtdVaqueiros} Vaqueiros</span>
                        <span style={{ color: "#d8b4fe", fontWeight: "600" }}>R$ {cat.lotes["2º Lote"].valorVaqueiros.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span>🐴 {cat.lotes["2º Lote"].qtdCavalosVinculados} Cavalos c/ vaqueiro</span>
                        <span style={{ color: "#d8b4fe", fontWeight: "600" }}>R$ {cat.lotes["2º Lote"].valorCavalosVinculados.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  </div>

                  <div style={{ background: "rgba(245, 158, 11, 0.08)", padding: "16px", borderRadius: "10px", border: "1px solid rgba(245, 158, 11, 0.25)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px dashed rgba(245, 158, 11, 0.35)", paddingBottom: "8px", marginBottom: "12px" }}>
                      <span style={{ fontSize: "12px", color: "#f59e0b", textTransform: "uppercase", fontWeight: "800", letterSpacing: "0.5px" }}>
                        Cavalos avulsos
                      </span>
                      <strong style={{ color: "#fff", fontSize: "16px" }}>
                        R$ {(cat.avulsos?.valorCavalos || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </strong>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", color: "rgba(255,255,255,0.8)" }}>
                      <span>🐴 {cat.avulsos?.qtdCavalos || 0} cadastro(s) sem vaqueiro</span>
                      <span style={{ color: "#fcd34d", fontWeight: "600" }}>Taxa própria</span>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: "32px", padding: "20px", background: "rgba(46, 204, 113, 0.05)", borderRadius: "12px", border: "1px solid rgba(46, 204, 113, 0.2)", display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <span style={{ fontSize: "14px", color: "#a3a3a3", textTransform: "uppercase", fontWeight: "bold", display: "block" }}>TOTAL ARRECADADO:</span>
              <small style={{ color: "rgba(255,255,255,.5)" }}>
                Vendas {`R$ ${receitaVendas.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} + entradas {`R$ ${entradasManuais.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
              </small>
            </div>
            <strong style={{ fontSize: "28px", color: "#2ecc71" }}>
              R$ {receitaAprovada.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </strong>
          </div>
        </div>

        <div className="pc-card">
          <div className="pc-card__header">
            <h3 className="pc-card__title">
              <FaHandHoldingUsd style={{ marginRight: 10, color: "#10b981" }} />
              Entradas Recentes
            </h3>
          </div>

          {statsData?.entradasRecentes?.length > 0 ? (
            <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              {statsData.entradasRecentes.map((entrada) => (
                <div key={entrada._id} style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "space-between", alignItems: "center", paddingBottom: "12px", borderBottom: "1px solid var(--pc-border)" }}>
                  <div style={{ minWidth: "180px" }}>
                    <strong style={{ display: "block", color: "#fff", marginBottom: "4px", fontSize: "15px" }}>
                      {entrada.tipo || "Entrada"}
                    </strong>
                    <span style={{ fontSize: "13px", color: "#a3a3a3" }}>
                      {entrada.descricao || "Sem descrição"}
                    </span>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <strong style={{ color: "#10b981", fontSize: 16 }}>
                      R$ {Number(entrada.valor || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                    </strong>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.4)", marginTop: "5px" }}>
                      {new Date(entrada.dataEntrada || entrada.createdAt).toLocaleDateString("pt-BR")}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="pc-empty" style={{ background: "transparent", border: "none", padding: "16px 0", color: "#a3a3a3" }}>
              Nenhuma entrada manual registrada ainda.
            </div>
          )}
        </div>

        <div className="pc-card">
          <div className="pc-card__header">
            <h3 className="pc-card__title">
              <FaChartLine style={{ marginRight: 10, color: "var(--pc-accent)" }} />
              Últimas Inscrições (Com Valores)
            </h3>
          </div>
          
          {statsData?.ultimasAtividades?.length > 0 ? (
            <div style={{ marginTop: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
              {statsData.ultimasAtividades.map((ativ) => (
                <div key={ativ._id} style={{ display: "flex", flexWrap: "wrap", gap: "12px", justifyContent: "space-between", alignItems: "center", paddingBottom: "12px", borderBottom: "1px solid var(--pc-border)" }}>
                  <div style={{ minWidth: "150px" }}>
                    <strong style={{ display: "block", color: "#fff", marginBottom: "4px", fontSize: "15px" }}>{ativ.nomeVaqueiro}</strong>
                    <span style={{ fontSize: "13px", color: "#a3a3a3" }}>
                      {ativ.categoria} {ativ.cavalo ? ` • 🐴 ${ativ.cavalo}` : ""}
                    </span>
                  </div>
                  <div style={{ textAlign: "right", minWidth: "120px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", justifyContent: "flex-end" }}>
                      <span style={{ fontSize: "15px", fontWeight: "bold", color: "#fff" }}>
                        R$ {Number(ativ.valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                      <span style={{ 
                        display: "inline-block", padding: "4px 8px", borderRadius: "8px", fontSize: "11px", fontWeight: "800", textTransform: "uppercase",
                        background: ativ.statusPagamento === "pago" ? "rgba(46, 204, 113, 0.15)" : ativ.statusPagamento === "pendente" ? "rgba(243, 156, 18, 0.15)" : "rgba(231, 76, 60, 0.15)",
                        color: ativ.statusPagamento === "pago" ? "#2ecc71" : ativ.statusPagamento === "pendente" ? "#f39c12" : "#e74c3c"
                      }}>
                        {ativ.statusPagamento}
                      </span>
                    </div>
                    <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.4)", marginTop: "6px" }}>
                      {new Date(ativ.createdAt).toLocaleString('pt-BR')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="pc-empty" style={{ background: "transparent", border: "none", padding: "16px 0", color: "#a3a3a3" }}>
              Nenhuma atividade registrada ainda.
            </div>
          )}
        </div>

      </div>
    </div>
  )
}